{
  "RESET_PASSWORD": {
    "TITLE": "Reset lozinke",
    "DESCRIPTION": "Unesite email adresu koju koristite za prijavu u kontaktni centar kako biste dobili instrukcije za resetiranje lozinke.",
    "GO_BACK_TO_LOGIN": "Ako se želite vratiti na stranicu za prijavu,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Molimo, unesite e-mail.",
      "ERROR": "Molimo, unesite validan e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link za reset lozinke je poslan na zadani e-mail.",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "SUBMIT": "Pošalji"
  }
}
